import React from "react";
import { RCM_SERVICES } from "../lib/site-data";
import {
  CalendarCheck,
  ShieldCheck,
  Code2,
  FileSpreadsheet,
  Send,
  Repeat2,
  AlertTriangle,
  Gavel,
  Wallet,
} from "lucide-react";

const ICONS = [
  CalendarCheck,
  ShieldCheck,
  Code2,
  FileSpreadsheet,
  Send,
  Repeat2,
  AlertTriangle,
  Gavel,
  Wallet,
];

export const RCMServices = () => (
  <section id="rcm" data-testid="rcm-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-green-100 text-[color:var(--brand-green-700)] px-4 py-1.5 text-xs font-bold tracking-[0.2em] uppercase">
          Revenue Cycle Management
        </span>
        <h2
          data-testid="rcm-title"
          className="font-display mt-5 text-4xl md:text-5xl font-bold text-navy"
        >
          End-to-end RCM — from first appointment to final appeal.
        </h2>
        <p className="mt-5 text-lg text-slate-600 leading-relaxed">
          Nine specialized services delivered by a team obsessed with clean claims, fast cash, and
          fewer denials — purpose-built for US healthcare providers and facilities.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {RCM_SERVICES.map((s, i) => {
          const Icon = ICONS[i] || FileSpreadsheet;
          return (
            <article
              key={s.title}
              data-testid={`rcm-card-${i}`}
              className="group relative bg-white border border-slate-200 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl hover:border-[color:var(--brand-green-300)] transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 rounded-xl bg-brand-green-100 text-[color:var(--brand-green-700)] flex items-center justify-center group-hover:bg-navy group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <span className="font-display text-sm text-slate-400 tabular-nums">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display mt-6 text-xl font-semibold text-navy">{s.title}</h3>
              <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">{s.body}</p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
